import React from "react";

import { EnglishOnlyNotice } from "components/products/muggleTestV0/components/english-only-notice";
import { PUBLIC_PAGES_COPY } from "copy/publicPages";
import { useCopy } from "i18n/useCopy";

import Agreement from "./Agreement";

/** Terms & Privacy page: the legal text stays English, headed by a one-line notice in other locales. */
const Terms: React.FC = () => {
  const copy = useCopy();

  return (
    <>
      <EnglishOnlyNotice
        message={copy.text(PUBLIC_PAGES_COPY.legalPages.englishOnlyNotice)}
        className="px-4 py-3 text-center"
      />
      <Agreement />
    </>
  );
};

export default Terms;
